import { useMutation, useQuery } from "@tanstack/react-query";

import {
  Button,
  Image,
  Modal,
  Popconfirm,
  Table,
  Typography,
  message,
} from "antd";

import AddAlbum from "../components/Add/Album";
import AudioPlayer from "../components/AudioPlayer";
import Player from "../components/Player";
import Remove from "../components/Remove";
import useSearch from "../components/Search";
import {
  deleteAlbum,
  getAllAlbum,
  getAllArtists,
  getAllSubscriptions,
  getGenres,
} from "../utils/api";

const Album = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["albums"],
    queryFn: async () => await getAllAlbum(),
  });

  const { mutate, isLoading: isLoading2 } = useMutation(
    async (values) => await deleteAlbum(values),
    {
      onSuccess: () => {
        messageApi.success(`Deleted`);
        refetch();
      },
    }
  );
  const { data: subs } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: async () => await getAllSubscriptions(),
  });

  const { data: categories } = useQuery({
    queryKey: ["genres"],
    queryFn: async () => await getGenres(),
  });
  const { data: artists } = useQuery({
    queryKey: ["artists"],
    queryFn: async () => await getAllArtists(),
  });

  const search = useSearch();

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",

      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div>
            <AddAlbum
              refetch={refetch}
              update={record}
              categories={categories}
              artists={artists}
            />
            <Remove
              id={record._id}
              type="Music"
              refech={refetch}
              subs={subs?.filter((item) =>
                record?.subscriptions?.includes(item._id)
              )}
            />
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => mutate(record._id)}
            >
              <Button
                danger
                style={{
                  marginTop: 10,

                  width: "100%",
                }}
                loading={isLoading2}
              >
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },

    {
      title: "Cover",
      dataIndex: "cover",
      render(value, record) {
        return (
          <Image
            src={record.cover}
            style={{
              width: 50,
              height: 50,
              borderRadius: 5,
            }}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      ...search("name"),
    },
    {
      title: "Release Year",
      dataIndex: "releaseYear",
    },

    {
      title: "Songs",
      dataIndex: "songs",
      render(value, record) {
        return (
          <Button
            type="primary"
            onClick={() =>
              Modal.info({
                width: 800,
                title: "Songs",
                content: (
                  <Table
                    columns={[
                      { title: "Name", dataIndex: "name" },
                      {
                        title: "Video",
                        dataIndex: "video",
                        render(value, record) {
                          return <Player link={record.video} />;
                        },
                      },
                      {
                        title: "Audio",
                        dataIndex: "audio",
                        render(value, record) {
                          return <AudioPlayer link={record.audio} />;
                        },
                      },
                    ]}
                    dataSource={record.songs}
                  />
                ),
              })
            }
          >
            View
          </Button>
        );
      },
    },

    {
      title: "Genres",
      dataIndex: ["genres"],
      render(value, record) {
        return value?.map((item) => item.name).join(", ");
      },
    },
  ];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Albums
        </Typography>

        <div>
          <AddAlbum
            refetch={refetch}
            categories={categories}
            artists={artists}
          />
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={isLoading}
        scroll={{ x: 1000 }}
      />
    </div>
  );
};

export default Album;
